import noOp from '../strategies/no-op-behaviour';
import timeSpent from '../strategies/time-spent';
import pointReach from '../strategies/screen-point-reached';
import onUrl from '../strategies/url-strategy';

var resolve = function(options){
    var strategies = [],
        options = options || {},
        names = [];
    strategies.push(noOp());
    if (options.time) {
        strategies.push(timeSpent(options.time));
        names.push('time');
    }
    if (options.point) {
        strategies.push(pointReach(options.point));
        names.push('point');
    }
    if (options.url) {
        strategies.push(onUrl(options.url));
        names.push('url');
    }
    return Promise.all(strategies).then(function(values) {
        var result = {};
        for (var i = 1; i < values.length; i++) {
            result[names[i - 1]] = values[i];
        }
        if (options.custom) {
            result.custom = options.custom;
        }
        if (options.prompt) {
            result.prompt = options.prompt;
        }
        return Promise.resolve(result);
    });
}

export default resolve;


//////////////////
// WEBPACK FOOTER
// ./src/utils/resolve-behaviour.js
// module id = 6
// module chunks = 0